// extracted by mini-css-extract-plugin
module.exports =  {"background":"background-Xro_t","icon":"icon-UFaeB"};